export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Sarah M.',
    handle: '@sarahandmilo',
    avatar: 'https://public.readdy.ai/ai/img_res/70736fbfe5ff29c463a1a5d3a5d49ee7.jpg',
    review: 'I used to dread walks because of cleanup. This thing changed everything. No mess, no smell on my hands. My golden retriever and I go on twice as many walks now!',
    rating: 5,
    dog: 'Golden Retriever owner',
  },
  {
    id: 2,
    name: 'James T.',
    handle: '@jamesthedogdad',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20in%20his%2040s%20with%20a%20labrador%20dog%2C%20warm%20natural%20outdoor%20lighting%2C%20casual%20lifestyle%20portrait%2C%20soft%20background%2C%20happy%20expression%2C%20natural%20colors&width=80&height=80&seq=11&orientation=squarish',
    review: 'Bought the scooper for my backyard. Works perfectly on grass. It always sucked having to be so careful to not make a mess, this literally fixed that problem overnight.',
    rating: 5,
    dog: 'Labrador owner',
  },
  {
    id: 3,
    name: 'Emily R.',
    handle: '@emilyandbiscuit',
    avatar: 'https://static.readdy.ai/image/b5a48cb165ee6dba59bd8dc08534cd52/90a260520840feaea279333ba3659a28.png',
    review: "It clips right onto my leash. I take it everywhere. It's so discreet and clean. I've already recommended it to everyone at the dog park.",
    rating: 5,
    dog: 'Golden Retriever owner',
  },
  {
    id: 4,
    name: 'Carlos V.',
    handle: '@carlosandchico',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20in%20his%2030s%20with%20a%20french%20bulldog%2C%20warm%20natural%20outdoor%20lighting%2C%20casual%20lifestyle%20portrait%2C%20soft%20background%2C%20happy%20expression%2C%20natural%20colors&width=80&height=80&seq=13&orientation=squarish',
    review: 'Super easy to clean, super easy to use. I was skeptical at first but after one walk I was sold. The quality feels premium for the price. 100% worth it.',
    rating: 5,
    dog: 'French Bulldog owner',
  },
  {
    id: 5,
    name: 'William K.',
    handle: '@williamandluna',
    avatar: 'https://static.readdy.ai/image/b5a48cb165ee6dba59bd8dc08534cd52/7fc410c8886ffe199473f88a9592e21b.png',
    review: 'I have two dogs and this makes cleanup so fast. What used to take minutes now takes seconds. The Blue Breeze style is my favorite and it\'s so reliable.',
    rating: 5,
    dog: 'Yorkie owner',
  },
  {
    id: 6,
    name: 'Priya N.',
    handle: '@priyaandpeanut',
    avatar: 'https://static.readdy.ai/image/b5a48cb165ee6dba59bd8dc08534cd52/a4bb287f240343388de2cf8d0d491cdd.png',
    review: 'Finally a product that actually works as advertised. The bag dispenser in the scooper is genius — everything in one tool. No more fumbling with separate bags on walks.',
    rating: 5,
    dog: 'Beagle owner',
  },
];
